<template>
  <div>
    <v-container v-if="showCard">
      <v-tabs>
        <v-tab>Detalles del cupón</v-tab>
        <v-tab>Canjes</v-tab>
        <!-- <v-tab>QR</v-tab> -->

        <v-tab-item>
          <v-card flat>
            <!-- Título y descripción -->
            <v-card-title class="text-h5 font-weight-bold">
              {{ dataCupon.nom }}
            </v-card-title>
            <v-card-subtitle class="text-body-1">{{
              dataCupon.dsc
              }}</v-card-subtitle>

            <v-card-text>
              <v-list dense>
                <!-- Información Básica -->
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>ID:</v-list-item-title>
                    <v-list-item-subtitle>{{
                      dataCupon.id
                      }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Activo:</v-list-item-title>
                    <v-list-item-subtitle>{{
                      dataCupon.act ? "Sí" : "No"
                      }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Cdg:</v-list-item-title>
                    <v-list-item-subtitle>{{
                      dataCupon.cdg
                      }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Fechas:</v-list-item-title>
                    <v-list-item-subtitle>
                      Inicio: {{ dataCupon.fin }} | Fin: {{ dataCupon.ffn }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Pag:</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ dataCupon.pag.tp }} ({{ dataCupon.pag.cn }})
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider v-if="dataCupon.prsSearched" class="my-2"></v-divider>

                <!-- Sección: Presentaciones  -->
                <v-list-item v-if="dataCupon.prsSearched">
                  <v-list-item-content>
                    <v-list-item-title>Presentaciones:</v-list-item-title>

                    <v-list dense>
                      <!-- Título de Categorías -->
                      <v-list-item-title v-if="dataCupon.prsSearched.Categorias.length">
                        <strong>Categorías:</strong>
                      </v-list-item-title>

                      <!-- Categorías -->
                      <v-list-item v-for="(categoria, idx) in dataCupon.prsSearched
                        .Categorias" :key="'cat-' + idx">
                        <v-list-item-content>
                          <v-list-item-title>{{ categoria.Nombre }} ({{
                            categoria.cn
                          }}
                            incluido)</v-list-item-title>
                          <v-list-item-subtitle>
                            ID: {{ categoria.Familia }} | Departamento:
                            {{ categoria.Departamento }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <!-- Espacio entre Categorías y Productos -->
                      <v-divider v-if="
                        dataCupon.prsSearched.Categorias.length &&
                        dataCupon.prsSearched.Productos.length
                      " class="my-2"></v-divider>

                      <!-- Título de Productos -->
                      <v-list-item-title v-if="dataCupon.prsSearched.Productos.length">
                        <strong>Productos:</strong>
                      </v-list-item-title>

                      <!-- Productos -->
                      <v-list-item v-for="(producto, idx) in dataCupon.prsSearched
                        .Productos" :key="'prod-' + idx">
                        <v-list-item-content>
                          <v-list-item-title>{{ producto.Nombre }} ({{
                            producto.cn
                          }}
                            incluido)</v-list-item-title>
                          <v-list-item-subtitle>
                            Precio: {{ producto.Precio }}
                            {{ producto.Moneda }} | Código:
                            {{ producto.Codigo }} | Departamento:
                            {{ producto.Departamentos.join(", ") }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-2"></v-divider>

                <!-- Usos y VDI -->
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Tipo de usos:</v-list-item-title>
                    <v-list-item-subtitle>{{
                      dataCupon.tus
                      }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Usos:</v-list-item-title>
                    <v-list-item-subtitle>{{
                      dataCupon.uss
                      }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <!-- <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>VDI:</v-list-item-title>
                    <v-list-item-subtitle>{{
                      dataCupon.vdi
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item> -->
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <DataTable :config="dtConfig" :data="processedCanjes" />
        </v-tab-item>

        <!-- <v-tab-item>
          <v-img src="img"></v-img>
        </v-tab-item> -->
      </v-tabs>
    </v-container>
    <v-card v-else> No hay detalles por mostrar </v-card>
  </div>
</template>

<script>
import Cliente from "../../../clases/Cliente.js";
import DataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "CampanasCuponesForm",
  components: {
    DataTable,
  },
  props: ["dataCupon", "canjes"],
  data() {
    return {
      showCard: false,
      dtConfig: {
        selectableRow: false,
        allowExport: true,
        rawText: "Canjes de Cupón",
        orderByCol: { Field: "nombres" },
        selectConfig: {
          idRowData: "id",
        },
        fields: [
          { text: "Cliente", value: "nombres" },
          { text: "ID", value: "id" },
          { text: "Usos", value: "usos" },
          { text: "Cumpleaños", value: "cumple" },
        ],
      },
    };
  },
  computed: {
    processedCanjes() {
      if (!this.canjes) return [];
      const rowclientes = Cliente.getClientsList();
      return this.canjes.map((canje) => {
        const idCliente = canje.id.replace("PGS-", "");
        const cliente = rowclientes.find((c) => c.Id === idCliente);
        return {
          ...canje,
          nombres: cliente
            ? (cliente.Nombres || "") + " " + (cliente.Apellidos || "")
            : canje.sub
            ? canje.sub.Nom
            : "N/A",
          cumple: cliente ? cliente.FechaNacimiento || "N/A" : "N/A",
        };
      });
    },
  },
  methods: {
  },
  beforeMount() {
    if (this.dataCupon) {
      // console.log("datacupon", sthis.dataCupon);
      this.showCard = true;
    }
  },
};
</script>
